import React from "react";
import { useState, useEffect, useContext } from "react";
//import auth from "../firebase";
import Loading from "./Loading";
import { MyContext } from "../context";
//import ClientDashboard from "../Pages/components/ClientDashboard"
//import Options from "./components/options";
import ClientPlant from "./components/ClientPlant"
import TicketDashboard from "./components/TicketDashboard"
import supabase from "../Supa";

function Home() {
  const { updateUsersEmail, updateUserName, Logins, updateLogins, updateuserId, updatePhone, updateProfile_url } = useContext(MyContext);
  const [loading, setLoading] = useState(true);

  // Check if User have Monday.com Account

 /*

  const MondayUser = async (e) => {
    let query = "query { users { name email url }}";

    try {
      const response = await fetch("https://api.monday.com/v2", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "eyJhbGciOiJIUzI1NiJ9.eyJ0aWQiOjI0MjI1MTIwMCwidWlkIjo0MDYwOTU4OCwiaWFkIjoiMjAyMy0wMy0wN1QxMzoxMTo1NS4wMDBaIiwicGVyIjoibWU6d3JpdGUiLCJhY3RpZCI6MTU3ODUwNjgsInJnbiI6ImV1YzEifQ.Hxj893XbG-cnTCAzms47DTLl3TpwqWc1wVX1N9Kti6Q",
        },
        body: JSON.stringify({
          query,
        }),
      });
      const data = await response.json();

      const emails = await data.data.users.map((user) => user.email);

      if (emails.includes(e)) {
        setAccounCheck(true);
        const user = await data.data.users.find((u) => u.email === e);
        //updateUserName(user.name);
        //window.localStorage.setItem("UserName", JSON.stringify(user.name));

        //updateUsersEmail(user.email);
        //setUsers([user]);
        setLoading(false);
      } else {
        setAccounCheck(false);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };
 */
   // Check the User who Loggin
   const getUserInformation = async (e) => {
    try {
     
        const { data, error } = await supabase
        .from('UserTicket')
        .select()
        .eq("User_id", e);

        //If UserTicket Table data return 0 it means this table dont have this User

        if(data.length === 0)
          {return setLoading(false)}

        updateUserName(data[0].Name +" "+ data[0].Surname)
        sessionStorage.setItem('user',JSON.stringify(data))
        window.localStorage.setItem("UserName", data[0].Name +" "+ data[0].Surname);
        updateuserId(e)
        updatePhone(data[0].Phone)
        if(data[0].Image !== null){
        updateProfile_url(data[0].Image) 
        }

        //If UserTicket Table have this User and Local Storage dont have View Item create the Local 
        //storage item and update the Logings correct view
         
         if(!sessionStorage.getItem('view')){
          updateLogins("TicketSystem")
          sessionStorage.setItem('view',"TicketSystem")
        }
   
        setLoading(false);
        
       
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {

  

    if(sessionStorage.getItem('view')){
      let view = sessionStorage.getItem('view')
      updateLogins(view)
    }

   

    if(sessionStorage.getItem('id')){
      let id = sessionStorage.getItem('id')
      getUserInformation(id)
    }

    if(sessionStorage.getItem('token')){
      let data = JSON.parse(sessionStorage.getItem('token'))
      updateUsersEmail(data.user.email)
      window.localStorage.setItem(
        "UserEmail",data.user.email
      );
    }

    /* 
    
   auth.onAuthStateChanged((userAuth) => {
      if (userAuth) {
        setUserAuthEmail(userAuth.email);
        MondayUser(userAuth.email);

        window.localStorage.setItem(
          "UserEmail",
          JSON.stringify(userAuth.email)
        );
      }
    });*/
  }, []); 
  
 
  
  const display = () => {
    if (Logins === "TicketSystem") {
      return (
        <div>
        {/*  <Options />  <ClientPlant />*/}
          <div>&nbp;</div>
         
         <TicketDashboard />

        </div>
      );
    } else {
      return (
        <div>
         <div>&nbp;</div>
         <ClientPlant />
         
         
        </div>
      );
    }
  };

  return (
    <>
      {loading ? <Loading /> : display()}

      {/*
        
        {accountCheck
            ? <div><p>true</p> <button className="btn1 btn-default" onClick={out}>Logout</button> </div>
            :<div><p>false</p> <button className="btn1 btn-default" onClick={out}>Logout</button> </div>}
        
        Array.isArray(users) && users.map((user, index) => (
      <div key={index}>
      {userAuthEmail}
        <p>Name: {user.name}</p>
        <p>Email: {user.email}</p>
        <p>URL: {user.url}</p>
      </div>
        ))*/}
    </>
  );
}

export default Home;
